import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=41eb7e64&scoped=true&"
import script from "./DefaultPage.vue?vue&type=script&lang=ts&"
export * from "./DefaultPage.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultPage.vue?vue&type=style&index=0&id=41eb7e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eb7e64",
  null
  
)

export default component.exports